import React, { useState } from 'react'
import { Container, Navbar, Nav } from "react-bootstrap"
import "./Navbars.css"
import { IoLogoTwitter } from "react-icons/io"
import { SiDiscord } from "react-icons/si"
import twitter from "../../Images/twitter.svg"
import discord from "../../Images/discord.svg"
import { GiHamburgerMenu } from "react-icons/gi"
// import { Link } from 'react-scroll';
import { Link } from "react-router-dom"
function Navbars({ active }) {
    const [show, setShow] = useState(false);
    const scroller = (id) => {
        document.getElementById(id).scrollIntoView();
    }
    return (
        <>
            {/* <div className="container-fluid cont_main">


                <Navbar collapseOnSelect expand="lg" className="cont_navbar"> */}

            {/* <Navbar.Brand href="#home">React-Bootstrap</Navbar.Brand> */}
            {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav" className="cont_colapse"> */}
            {/* <Nav className="me-auto">


                        </Nav> */}
            {/* <div className="cont_org"></div>
                        <div className="cont_blue"></div>
                        <div className="cont_yellow"></div>

                        <Nav className="cont_na">

                            <Nav.Link href="#homes" className="cont_nav home">Home</Nav.Link>
                            <Nav.Link href="#about" className="cont_nav navs">About</Nav.Link>
                            <Nav.Link href="#mint" className="cont_nav navs">Mint</Nav.Link>
                            <Nav.Link href="#road" className="cont_nav navs">Roadmap</Nav.Link>
                            <Nav.Link href="#faq" className="cont_nav navs">Faq's</Nav.Link>
                            <Nav.Link target='_blank' href="https://twitter.com/" className="cont_twitter tweet">
                                <img className="twitter" src={twitter} />
                            </Nav.Link>
                            <Nav.Link target='_blank' href="https://discord.com/" className="cont_twitter cordi">
                                <img className="twitter" src={discord} />
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>

                </Navbar>
            </div> */}

            <div className="container-fluid cont_main" >


                <Navbar onToggle={show}
                    expanded={show} collapseOnSelect expand="lg" className="cont_navbar">

                    <Navbar.Brand href="#home" >

                        {/* <div className="broad">
                            <div className="cont_org one"></div>
                            <div className="cont_blue one"></div>
                            <div className="cont_yellow one"></div>
                        </div> */}

                    </Navbar.Brand>
                    <div className="menu_icon" onClick={() => show ? setShow(false) : setShow(true)} > <GiHamburgerMenu /></div>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav" className="cont_colapse">


                        {/* <div className="cont_org"></div>
                        <div className="cont_blue"></div>
                        <div className="cont_yellow"></div> */}

                        <Nav className=" cont_na">
                            <Link
                                // activeClass="active"
                                className={`navtablink tabsss hiome active`}
                                to="#homes"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => scroller("homes")}
                            >
                                Home
                            </Link>
                            <Link
                                // activeClass="active"
                                className={`navtablink tabsss ${active === "about" ? "active" : null}`}
                                to="#about"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => scroller("about")}
                            >
                                About
                            </Link>
                            <Link
                                // activeClass="active act"
                                className={`navtablink tabsss minss ${active === "mints" ? "active act" : null}`}
                                to="#mints"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => scroller("mints")}
                            >
                                Mint
                            </Link>
                            <Link
                                // activeClass="active"
                                className={`navtablink tabsss  ${active === "road" ? "active" : null}`}
                                to="#road"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => scroller("road")}
                            >
                                Roadmap
                            </Link>
                            <Link
                                // activeClass="active"
                                className={`navtablink tabsss  ${active === "faq" ? "active" : null}`}
                                to="#faq"
                                spy={true}
                                smooth={true}
                                offset={-70}
                                duration={500}
                                onClick={() => scroller("faq")}
                            >
                                Faq's
                            </Link>
                            {/* <Nav.Link href="#homes" className="cont_nav home">Home</Nav.Link>
                            <Nav.Link href="#about" className="cont_nav navs">About</Nav.Link>
                            <Nav.Link href="#mint" className="cont_nav navs">Mint</Nav.Link>
                            <Nav.Link href="#road" className="cont_nav navs">Roadmap</Nav.Link>
                            <Nav.Link href="#faq" className="cont_nav navs">Faq's</Nav.Link> */}
                            <div className="icons">
                                <Nav.Link target='_blank' href="https://twitter.com/SolarBearsNFT" className="cont_twitter tweet">
                                    <img className="twitter" src={twitter} />
                                </Nav.Link>
                                <Nav.Link target='_blank' href="https://discord.gg/XYRkqRg9" className="cont_twitter cordi">
                                    <img className="twitter" src={discord} />
                                </Nav.Link>
                            </div>

                        </Nav>


                        {/* <Nav className="cont_na">


                        </Nav> */}
                    </Navbar.Collapse>

                </Navbar>
            </div>

        </>
    )
}

export default Navbars
